export const APP_VERSION = '3.86.2';
